import { createFileRoute } from '@tanstack/react-router'
import AccountingDashboard from '@/features/accounting-dashboard'

export const Route = createFileRoute('/_authenticated/accounting-dashboard/')({
  component: AccountingDashboard,
}) 